import { combineReducers } from "redux"

import cart from "./cart"
import productList from "./product-list"
import entity from "./entity"
import productFilter from "./product-filter"
import openOrders from "./open-orders"
import payment from "./payment"
import reservation from "./reservation"

export default combineReducers({
  entity,
  cart,
  productFilter,
  openOrders,
  payment,
  productList,
  reservation
})
